export interface UnsubscribeFormProps {
  onSubmit?: Function;
}

export enum UnsubscribeOptions {
  often = 'TOO_FREQUENT_MESSAGES',
  push = 'PREFER_PUSH_NOTIFICATIONS',
  notInterested = 'NOT_INTERESTED_IN_EMAILS',
  stopWearing = 'STOPPED_USING_LENSES',
  enoughInfo = 'ENOUGH_INFORMATION_IN_APP',
  lazerCorrection = 'LASER_VISION_CORRECTION_DONE',
  other = 'OTHER',
}
